/*
 * Community Hub Form Submit via Ajax
 */
document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#community-form');
    if (!form) return;

    const formCommunityHubSubmit = () => {
        const formData = new FormData(form);
        const formValues = new URLSearchParams(formData).toString();
        const xhr = new XMLHttpRequest();

        xhr.open('POST', `${window.location.origin}/wp-content/themes/asbestos/ajax/community-form.php`);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        xhr.onload = () => {
            if (xhr.status !== 200) return;

            hideFormElements(form);
            displayThankYouMessage();
        };

        xhr.send(formValues);
    };

    const hideFormElements = (newsletter) => {
        const elementsToHide = [
            '.c-form__group',
            '.c-form__group-2col',
            '.c-disclaimer--form',
            '.c-form__submit'
        ];
        elementsToHide.forEach(selector => {
            newsletter.querySelectorAll(selector).forEach(element => element.style.display = 'none');
        });
    };

    const displayThankYouMessage = () => {
        form.innerHTML = `
            <h2>Thank You</h2>
            <p>We have received your request. A member of our team will reach out to you shortly to discuss how we can collaborate together. 
            You can email our editor, Walter Pacheco, directly at 
            <a href="mailto:wpacheco@asbestos.com">wpacheco@asbestos.com</a>
            </p>
        `;
    };

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        formCommunityHubSubmit();
    });
});
